define('app/sf/collapse/empty/sf-collapse-empty-filter',[],function () {
	"use strict";
	return sdcEmptyNullFactory;
	function isEmpty(value) {
		return angular.isUndefined(value) ||
			value === null ||
			(angular.isArray(value) && value.length === 0) ||
			(angular.isObject(value) && Object.keys(value).length === 0);
	}
	function isNotEmpty(value) {
		return !isEmpty(value);
	}
	function sdcEmptyNullFactory(value) {
		if (!angular.isObject(value)) {
			return value === null ? undefined : value;
		}
		else {
			var obj = angular.filter(angular.map(value, sdcEmptyNullFactory), isNotEmpty);
			if (isNotEmpty(obj)) {
				return obj;
			}
			else {
				return undefined;
			}
		}
	}
});
